import React from "react";
import { getUpdateImagePartner } from "../../../../services/PartnerService";
import { uploadAvatarMutiImage } from "../../../../services/PartnerService";
import useAlertDialog from "../../../hooks/useAlertDialog";
import { AlertType } from "../../../hooks/common/useAttachAlertDialog";

export async function convertBase64Images(images: (string | File)[]) {
	const oldUrls = images.filter((img): img is string => typeof img === "string" && !img.startsWith("data:image"));
	const fileImages = images.filter((img): img is File => img instanceof File);

	let newImageUrls: string[] = [];

	if (fileImages.length > 0) {
		const uploadResults = await uploadAvatarMutiImage(fileImages);

		newImageUrls = uploadResults
			.map((res: any) => res?.url || res?.path)
			.filter(Boolean);
	}

	return [...oldUrls, ...newImageUrls];
}



export default function useUpdateImagePartner(props: { reload: () => void }) {
        const { openAlertDialog } = useAlertDialog();
    
    const loadUpdateImage = async (
        id: string,
        meetImages: (string | File)[],
        nearbyImages: (string | File)[],
        imagesEnabled?: boolean,
    ) => {
        try {
            const meetUrls = await convertBase64Images(meetImages);
            const nearbyUrls = await convertBase64Images(nearbyImages);
            await getUpdateImagePartner(id, meetUrls, nearbyUrls, imagesEnabled);
                openAlertDialog?.(AlertType.Success, "Update successfully!", () => {
					props.reload?.();
				});
        } catch (err) {
            console.error("Error in loadUpdateImage:", err);
        }
    };

    return {
        loadUpdateImage,
    };
}
